import { render } from "./GameRules.vue?vue&type=template&id=70490eac&scoped=true"
import script from "./GameRules.vue?vue&type=script&lang=js"
export * from "./GameRules.vue?vue&type=script&lang=js"

import "./GameRules.vue?vue&type=style&index=0&id=70490eac&scoped=true&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70490eac"]])

export default __exports__